import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'ant-design-vue/dist/antd.css';
import "./assets/styles/main.scss";
import Antd from 'ant-design-vue';
// import {Checkbox,Input,Button } from 'ant-design-vue';

import VueGtag from "vue-gtag-next";


import { VueReCaptcha } from 'vue-recaptcha-v3'

// components
import LogoCampaign from "@/components/LogoCampaign/LogoCampaign.vue";
import ConsentCampaign from "@/components/ConsentCampaign/ConsentCampaign.vue";
import PopupCookie from "@/components/PopupCookie/PopupCookie.vue";
import ButtonOpenCard from "@/components/ButtonOpenCard/ButtonOpenCard.vue";
import PopupCompleted from "@/components/PopupCompleted/PopupCompleted.vue";
import PopupAlert from "@/components/PopupAlert/PopupAlert.vue";


const app = createApp(App);
app
.use(VueGtag, {
    property: [
        { id: 'G-54GXVHRCX6' },
        { id: 'UA-112869046-2', default: true }
      ]
  })
.use(Antd)
// .use(Button)
// .use(Checkbox )
// .use(Input )
.component("LogoCampaign", LogoCampaign)
.component("ConsentCampaign", ConsentCampaign)
.component("PopupCookie", PopupCookie)
.component("ButtonOpenCard", ButtonOpenCard)
.component("PopupCompleted", PopupCompleted)
.component("PopupAlert", PopupAlert)
.use(VueReCaptcha, { siteKey: process.env.VUE_APP_Recaptcha })
.use(store)
.use(router)
.mount('#app')